import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import Footer from "./components/footer/footer";
import LeftNav from "./components/leftnav/lefnav";
import Routes from "./components/routes/routes";
import Dashboard from "./Pages/Dashboard/Dashboard";

if (process.env.NODE_ENV !== 'development') {
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
}

function App(props) {
  const authStatus = useSelector((state) => state.ins.authStatus);

  useEffect(() => {
    console.table(process.env.NODE_ENV, " Node Env");
  }, []);

  return (
    <div class="wrapper">
      {authStatus ? (
        <>
          <LeftNav />
        </>
      ) : null}

      <Routes />
      {authStatus ? (
        <>
          <Footer />
        </>
      ) : null}
    </div>
  );
}

export default App;
